import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ReimbursementService } from './reimbursement.service';
@Pipe({
  name: 'categoryName'
})
export class CategoryNamePipe implements PipeTransform {
  constructor(private reimbur: ReimbursementService) {
  }
  transform(catId: string): Observable<any> {
    if (!catId) {
      return of('');
    }
    return this.reimbur.getCategories()
      .pipe(map(res => {
        const catName = res.find(emp => emp.id === catId);
        if (!catName) {
          return '';
        }
        return catName.name;
      }));
  }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/category-name.pipe.ts